module.exports = __webpack_public_path__ + "img/PM_A02_back_cross_diagonal_en.4fbb9157.png";